import { render, staticRenderFns } from "./ForWinners.vue?vue&type=template&id=a2554dc0&scoped=true"
import script from "./ForWinners.vue?vue&type=script&lang=js"
export * from "./ForWinners.vue?vue&type=script&lang=js"
import style0 from "./ForWinners.vue?vue&type=style&index=0&id=a2554dc0&prod&lang=css&scoped=true"
import style1 from "./ForWinners.vue?vue&type=style&index=1&id=a2554dc0&prod&lang=css"
import style2 from "./ForWinners.vue?vue&type=style&index=2&id=a2554dc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2554dc0",
  null
  
)

export default component.exports